export const notEmpty = (value)=>{
    return value !== undefined;
};
export const notNull = (value)=>{
    return value !== null;
};
export const notNullOrEmpty = (value)=>{
    return value !== null && value !== undefined;
};
